import React from 'react';

import './index.css';

const Criteria = (props) => {
    const {name,value} = props;

    return (
        <p className="criteria">{name} is {value}</p>
    );
}

export default Criteria;


// WEBPACK FOOTER //
// ./src/scenes/Segments/components/SegmentsTable/components/Criteria/index.js